var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',{ref:"select",attrs:{"data-width":"100%"},on:{"change":function($event){return _vm.$emit('input', $event.target.value)}}},[(_vm.includeBlank)?_c('option',{attrs:{"value":""}}):_vm._e(),_vm._v(" "),_vm._l((_vm.options),function([value, label]){return _c('option',{key:value,domProps:{"value":value}},[_vm._v(_vm._s(label))])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }